// @ts-nocheck
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getGrades } from '@store/HR/HRSetting/jobgradeSlice.js';
import { Card, CardBody } from '@components/card/card.jsx';
import ModalComponent from '@components/Modal/ModalComponent.jsx';
import AddJobGrade from './AddJobGrade.jsx';
import { usePermissions } from '@Helper/Permisstions/usePermissions';
import Breadcrumb from '@components/Shared/Breadcrumb';
import Loading from '@components/Shared/Loader/Loading';
import NtxTable from '@components/DataTable/NtxTable.jsx';
import EditJobGrade from './EditJobGrade.jsx';

// const JobGrades = () => {
//   const { HasPermission } = usePermissions();
//   const [id, setId] = useState('');

//   const [Show, setShow] = useState(false);
//   const { t, i18n } = useTranslation();

//   const { Grades, loading, error } = useSelector((state) => state.Grades);
//   const dispatch = useDispatch();

//   useEffect(() => {
//     if (Grades?.length === 0) {
//       dispatch(getGrades());
//     }
//   }, []);

//   const columns = [
//     { title: t('Name'), key: 'Name' },
//     { title: t(''), key: 'action', className: 'text-end' },
//   ];

//   const tableData = Grades?.map((item) => {
//     let rowClass;

//     return {
//       Name: i18n.language === 'ar' ? item.name : item.name2,
//       action: (
//         <>
//           {HasPermission('ViewDetailsHrPerGrade') && (
//             <button
//               type="button"
//               className="btn btn-sm btn-outline-theme"
//               data-bs-toggle="modal"
//               data-bs-target="#Update"
//               onClick={() => setId(item.id)}>
//               <i className="far fa-lg fa-fw  fa-edit mx-1"></i>
//               {t('Button.Edit')}
//             </button>
//           )}
//         </>
//       ),

//       rowClass, // استخدم rowClass هنا
//     };
//   });

//   //___________________________________
//   var BcrumbList = [
//     {
//       name: 'Home',
//       link: ':moduleHome',
//     },
//     {
//       name: t('Jobgrades'),
//       link: null,
//     },
//   ];

//   return (
//     <>
//       <div className="d-flex align-items-center">
//         <Breadcrumb BreadcrumbList={BcrumbList} PageName={t('Jobgrades')} />
//         {HasPermission('AddHrPerGrade') && (
//           <div className="ms-auto">
//             <Link
//               to=""
//               className="btn me-1 btn-theme "
//               data-bs-toggle="modal"
//               data-bs-target="#modalAddGrade"
//               onClick={() => setShow(true)}>
//               <i className="fa fa-plus-circle fa-fw me-1"></i>
//               {t('AddNewJobDegree')}
//             </Link>
//           </div>
//         )}
//       </div>
//       <Card>
//         <Loading loading={loading} error={error}>
//           <CardBody>
//             <NtxTable
//               data={tableData || []}
//               columns={columns}
//               dataPerPage={10}
//               theadClass=""
//               tableClass="table text-nowrap table-hover "
//               enableSearch
//               showRecordsSelector
//             />
//           </CardBody>
//         </Loading>
//       </Card>

//       <ModalComponent title={t('AddGrade')} id="modalAddGrade" size="lg">
//         {Show && <AddJobGrade />}
//       </ModalComponent>

//       <ModalComponent id="Update" title={t('EditGrade')} size="lg">
//         {id && <EditJobGrade id={id} />}
//       </ModalComponent>
//     </>
//   );
// };

const JobGrades = () => {
  const { HasPermission } = usePermissions();
  const [id, setId] = useState('');

  const [Show, setShow] = useState(false);
  const { t, i18n } = useTranslation();

  const { Grades, loading, error } = useSelector((state) => state.Grades);
  const dispatch = useDispatch();

  useEffect(() => {
    if (Grades?.length === 0) {
      dispatch(getGrades());
    }
  }, []);

  const columns = [
    { title: t('Code'), key: 'Code' }, // Added
    { title: t('Name'), key: 'Name' },
    { title: t(''), key: 'action', className: 'text-end' },
  ];

  const tableData = Grades?.map((item) => {
    let rowClass;

    return {
      Code: item.code, // Added
      Name: i18n.language === 'ar' ? item.name : item.name2,
      action: (
        <>
          {HasPermission('ViewDetailsHrPerGrade') && (
            <button
              type="button"
              className="btn btn-sm btn-outline-theme"
              data-bs-toggle="modal"
              data-bs-target="#Update"
              onClick={() => setId(item.id)}>
              <i className="far fa-lg fa-fw  fa-edit mx-1"></i>
              {t('Button.Edit')}
            </button>
          )}
        </>
      ),

      rowClass, // استخدم rowClass هنا
    };
  });

  //___________________________________
  var BcrumbList = [
    {
      name: 'Home',
   link: ':moduleHome'
    },
    {
      name: t('Jobgrades'),
      link: null,
    },
  ];

  return (
    <>
      <div className="d-flex align-items-center">
        <Breadcrumb BreadcrumbList={BcrumbList} PageName={t('Jobgrades')} />
        {HasPermission('AddHrPerGrade') && (
          <div className="ms-auto">
            <Link
              to=""
              className="btn me-1 btn-theme "
              data-bs-toggle="modal"
              data-bs-target="#modalAddGrade"
              onClick={() => setShow(true)}>
              <i className="fa fa-plus-circle fa-fw me-1"></i>
              {t('AddNewJobDegree')}
            </Link>
          </div>
        )}
      </div>
      <Card>
        <Loading loading={loading} error={error}>
          <CardBody>
            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=""
              tableClass="table text-nowrap table-hover "
              enableSearch
              showRecordsSelector
            />
          </CardBody>
        </Loading>
      </Card>

      <ModalComponent title={t('AddGrade')} id="modalAddGrade" size="lg">
        {Show && <AddJobGrade />}
      </ModalComponent>

      <ModalComponent id="Update" title={t('EditGrade')} size="lg">
        {id && <EditJobGrade id={id} />}
      </ModalComponent>
    </>
  );
};

export default JobGrades;
